// Swiper Slider Mobile Menu
var swiperHeader = new Swiper(".projects-overview-header", {
  direction: "horizontal",
  slidesPerView: 1,
  centeredSlides: true,
  spaceBetween: 20,
  breakpoints: {
    768: {
      spaceBetween: 40
    }
  },
  pagination: {
    el: ".swiper-pagination-header",
    clickable: true,
    type: "fraction",
    formatFractionCurrent:
    function (number) {
      number = number.toString();
      while (number.length < 2) number = "0" + number;
      return number;
    },
    formatFractionTotal:
    function (number) {
      number = number.toString();
      while (number.length < 2) number = "0" + number;
      return number;
    }
  },
  navigation: {
    nextEl: ".swiper-button-header-next",
    prevEl: ".swiper-button-header-prev"
  },
});



// Swiper Slider Project Overview
var swiperOverview = new Swiper(".projects-overview", {
  direction: "horizontal",
  slidesPerView: "auto",
  centeredSlides: true,
  //freeMode: true,
  //speed: 1000,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    type: "fraction",
    formatFractionCurrent:
      function (number) {
        number = number.toString();
        while (number.length < 2) number = "0" + number;
        return number;
      },
      formatFractionTotal:
      function (number) {
        number = number.toString();
        while (number.length < 2) number = "0" + number;
        return number;
      }
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
/*   mousewheel: {
    releaseOnEdges: true,
    eventsTarget: "main",
  } */
});


// Swiper Slider Project Insights
var swiperInsights = new Swiper(".projects-insights", {
  direction: "horizontal",
  slidesPerView: "auto",
  centeredSlides: false,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
    type: "fraction",
    formatFractionCurrent:
      function (number) {
        number = number.toString();
        while (number.length < 2) number = "0" + number;
        return number;
      },
      formatFractionTotal:
      function (number) {
        number = number.toString();
        while (number.length < 2) number = "0" + number;
        return number;
      }
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  }
});



if (typeof projektLinks !== 'undefined') {

  // Button in Slider bekommt Link von aktuellem Projekt-Slide
  document.getElementById("zumProjektButton").href = projektLinks[0];
  swiperOverview.on('slideChange', function () {
    document.getElementById("zumProjektButton").href = projektLinks[swiperOverview.activeIndex];
  });

  /* 
  // Scrolling stoppen wenn Slider im Fokus (unexpected behaviour)
  var sliderEnabled = false;
  swiper.mousewheel.disable();

  function sliderEnable(){
    if(sliderEnabled === false){
      swiper.mousewheel.enable();
      sliderEnabled = true;
    }
  }
  function sliderDisable(){
    if(sliderEnabled === true){
      swiper.mousewheel.disable();
      sliderEnabled = false;
    }
  }

  function hoeheErrechnen(){
    let sliderPosition = document.querySelector(".projects-overview").getBoundingClientRect();
    if(sliderPosition.top >= document.querySelector("#topPaddingBar").offsetHeight * 1.5 && sliderPosition.bottom <= window.innerHeight){
      console.log("Slider in view.");
      sliderEnable();
    }
    else{
      sliderDisable();
    }
  }

  // Funktion aufrufen
  hoeheErrechnen();
  onresize = (event) => {hoeheErrechnen()};
  onscroll = (event) => {hoeheErrechnen()};
  */

}



